
import './App.css';
import ByMe from './components/ByMe/ByMe';
import AboutMe from './components/me/Me';
import Popped from './components/poppedUpWindow/Popped';
import Projects from './components/project/Project';
import HomeQuote from './components/Quate/Quate';
import Works from './components/recommends/Works';
import TaliServices from './components/Services/Services';
import TextFill from './components/TextFill/TextFill';
import LuxurySection from './components/TextImage/TextImage';
import FifthScreen from './screens/FifthScreen';
import Carousel from './screens/FirstScreen';
import ForthScreen from './screens/ForthScreen';
import SecondScreen from './screens/SecondScreen';
import ThirdScreen from './screens/ThirdScreen';

function App() {
  return <>
  <Carousel/>
  {/* <HomeQuote/> */}
  <SecondScreen/>
    <AboutMe/>
    <Works/>
   <FifthScreen/>


  {/* <LuxurySection/> */}
  <Projects/>
  <ForthScreen/>
  <ByMe/>

  </>
}

export default App;
